// This is the entry point for the home component
// React
import React, { FC, useEffect, useState } from 'react';

// Styling
import injectSheet from 'react-jss';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Components
import { Filter } from 'Containers/Filter';
import AudienceExplore from 'Containers/AudienceExplore';
import { SideBar } from 'Components/SideBar';

// Actions
import { clearFilterState } from 'Containers/Filter/actions/filter.actions';

// Utilities
import { getBuiltQuery } from 'Containers/Filter/utilities/query.utilities';

import { areEqual } from 'Utils/areEqual';
import { findDateFromDays } from 'Utils/findDateFromDays';
import { Track } from '../../../shared/analyticsManager';
import styleSheet from './styles';

interface Props {
  classes?: any;
  startDate?: string;
  endDate?: string;
  listId?: string;
}

const LeadsExplore: FC<Props> = (props: Props) => {
  const Selector = useSelector((selectors: any) => selectors, areEqual);

  const {
    prospectiveStudentsQuery,
    parentsOfProspectsQuery,
    otherQuery,
    usaQuery,
    internationalQuery,
    ageQuery,
    genderQuery,
    ethnicityQuery,
    intendedLevelOfStudyQuery,
    entryTermQuery,
    intendedMajorQuery,
    gpaQuery,
    testScoresQuery,
    dateRegisteredQuery,
    relativeEngagementQuery,
    totalTimeSpentQuery,
    scheduledVisitQuery,
    appliedQuery,
    activityWithInstitutionQuery,
    activityWithEABQuery,
    listMembershipQuery,
    locationsQuery,
    queryIsIncongruent,
  } = useSelector((selectors: any) => selectors.filter.query, areEqual);
  const dispatch = useDispatch();

  const { classes, startDate, endDate, listId } = props;

  const filterObject = getBuiltQuery(
    prospectiveStudentsQuery,
    parentsOfProspectsQuery,
    otherQuery,
    usaQuery,
    internationalQuery,
    ageQuery,
    genderQuery,
    ethnicityQuery,
    intendedLevelOfStudyQuery,
    entryTermQuery,
    intendedMajorQuery,
    gpaQuery,
    testScoresQuery,
    dateRegisteredQuery,
    relativeEngagementQuery,
    totalTimeSpentQuery,
    scheduledVisitQuery,
    appliedQuery,
    activityWithInstitutionQuery,
    activityWithEABQuery,
    listMembershipQuery,
    locationsQuery
  );

  const [isOpen, setIsOpen] = useState(true); // SideBar is set to be open by default

  const toggleMenu = () => {
    // platform specific tracking //
    dispatch(
      Track({
        event: 'FILTER_EVENT',
      })
    );
    setIsOpen(!isOpen);
  };

  const clearAllFilters = () => {
    clearFilterState(dispatch);
  };

  const dirtyCheck = () => {
    let isDirty = null;

    if (Selector) {
      Selector.filter.query.forEach((property: string) => {
        if (Selector.filter.query[property]) {
          isDirty = 'Filter settings will be lost';
        }
      });
    }
    return isDirty;
  };

  useEffect(() => {
    window.onbeforeunload = dirtyCheck;
    return () => {
      window.onbeforeunload = null;
    };
  });

  return (
    <SideBar
      isOpen={isOpen}
      toggleMenu={toggleMenu}
      clearAllClick={clearAllFilters}
      clearAllHidden={
        prospectiveStudentsQuery === '' &&
        parentsOfProspectsQuery === '' &&
        otherQuery === '' &&
        usaQuery === '' &&
        internationalQuery === '' &&
        ageQuery === '' &&
        genderQuery === '' &&
        ethnicityQuery === '' &&
        intendedLevelOfStudyQuery === '' &&
        entryTermQuery === '' &&
        intendedMajorQuery === '' &&
        gpaQuery === '' &&
        testScoresQuery === '' &&
        dateRegisteredQuery &&
        dateRegisteredQuery[1].value === findDateFromDays(-8) &&
        relativeEngagementQuery === '' &&
        totalTimeSpentQuery === '' &&
        scheduledVisitQuery === '' &&
        appliedQuery === '' &&
        activityWithInstitutionQuery === '' &&
        activityWithEABQuery === '' &&
        listMembershipQuery === '' &&
        locationsQuery === ''
      }
      showSidebar={listId === '-1'}
      showError={queryIsIncongruent}
      error="Incongruent Filters Detected"
    >
      <SideBar.SideBarContent isOpen={isOpen}>
        <Filter />
      </SideBar.SideBarContent>
      <SideBar.MainContent isOpen={isOpen}>
        <div className={classes.exploreWrapper}>
          <AudienceExplore
            filters={filterObject}
            Selector={Selector}
            startDate={startDate}
            endDate={endDate}
            listId={listId}
          />
        </div>
      </SideBar.MainContent>
    </SideBar>
  );
};

LeadsExplore.defaultProps = {
  classes: {},
  startDate: '',
  endDate: '',
  listId: '-1',
};

export default injectSheet(styleSheet)(LeadsExplore);
